<template>
  <div v-if="hasAccessToken()" class="page_content account_pg">

    <div class="sect_welcome">

      <div class="container welc_cont">
        <div class="row justify-content-center">
          <h1>Welkom bij MySurprise!</h1>
          <div class="mob_numb">Je mobiele nummer: <span>{{ this.getMsisdn }}</span></div>
        </div>

        <div class="account_welcome_contain">
          <div class="badge_section">
            <div v-if="percentageOfRedeemedCodesRounded>0" class="badge_section_image">
              <img :src="'static/img/millen_images/' + tierIcon()">
            </div>
            <div v-if="percentageOfRedeemedCodesRounded>0" class="welc_img_text text-center">{{ calculateTierTitle() }}</div>
          </div>

          <div v-if="percentageOfRedeemedCodesRounded>0" class="account_welcome_text">
            <p>De laatste 3 maanden heb je <span>{{ percentageOfRedeemedCodesRounded }}% van je ontvangen speelcodes</span>
              gebruikt.</p>
            <p>Hierdoor ben jij een <span>{{ calculateTierTitle() }}</span>. Kun je nog hoger komen?
            </p>
          </div>
          <div v-if="percentageOfRedeemedCodesRounded<=0" class="account_welcome_text">
            <p>U heeft de afgelopen 3 maanden geen codes ingewisseld.</p>
            <p>Herlaad en speel vandaag nog om kans te maken op een fysieke prijs of een van de
              Odido Surprises!</p>
          </div>

        </div>
      </div>

    </div>

    <div class="sect_codes">
      <!--   open codes  -->
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="text-center">Mijn speelcodes</h1>
            <div class="cards_box">
              <div class="cards_box_cont">

                <div v-if="pendingCodesLength > 0" class="text one_title">
                  Je hebt <span v-model="pendingCodesLength">{{ pendingCodesLength }}</span>
                  ongebruikte speelcode(s)
                </div>

                <div v-if="pendingCodesLength > 0" class="shown_items one"
                     v-for="(item, index) in visiblePendingCodes">

                  <div class="codes_inside">
                    <div class="d-flex flex-column flex-lg-row flex-md-row ">
                      <div class="d-flex flex-row align-items-center w-100">
                        <img src="static/img/millen_images/play_icon.png">
                        <div class="table_prnt">
                          <div class="table_chld">
                            <p class="code">Speelcode: {{ pendingCodes[index].code }}</p>
                            <p class="date">Geldig t/m:
                              {{ pendingCodes[index].expirationDate | formatDate }} </p>
                          </div>
                          <div class="table_chld">
                            <button @click.prevent="redirectCustomer(pendingCodes[index].code)"
                                    type="button" class="black_btn">Speel en
                              Win!
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

                <div v-if="pendingCodesLength > 3" class="show_more_btn one" @click="showMorePendingCodes()">
                  <a href=javascript:void(0) v-model="showMorePendingCodesText" class="show_more one">{{showMorePendingCodesText}} </a>
                  <i class="fashow one fa"
                     :class="showMorePendingCodesText === 'Toon meer' ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                </div>
                <div v-if="pendingCodesLength <= 0" class="text">Je hebt op dit moment geen
                  speelcodes. Waardeer op en
                  je krijgt meteen een code!
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!--   unclaimed prizes  -->
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="text-center mi_prizen_title">Mijn prijzen</h1>
            <div class="cards_box">
              <!--   unclaimed telco  -->
              <div class="cards_box_cont">

                <div v-if="unfinishedTelcoCodesLength > 0" class="text two_title">
                  Je kunt <span
                  v-model="unfinishedTelcoCodesLength">{{ unfinishedTelcoCodesLength }}</span>
                  prijzen
                  claimen
                </div>
                <div v-if="unfinishedTelcoCodesLength > 0" class="shown_items two"
                     v-for="(item, index) in visibleUnfinishedTelcoCodes">

                  <div class="codes_inside first table_prnt">
                    <div class="table_chld inside_img">
                      <img src="static/img/millen_images/surprises_icon.png">
                    </div>
                    <div class="table_chld">
                      <div class="table_chld inside_text">
                        <p class="code">Speelcode: {{ unfinishedTelcoCodes[index].code }}</p>
                        <p class="date">Geldig t/m: {{ unfinishedTelcoCodes[index].redemptionDate |
                          formatDate}} </p>
                      </div>
                      <div class="table_chld inside_button">
                        <button
                          @click.prevent="redirectCustomer(unfinishedTelcoCodes[index].code)"
                          type="button" class="black_btn">Claim je Surprise
                        </button>
                      </div>
                    </div>
                  </div>

                </div>

                <div v-if="unfinishedTelcoCodesLength > 3" class="show_more_btn two"
                     @click="showMoreUnfinishedTelcoCodes()">
                  <a href=javascript:void(0) v-model="showMoreUnfinishedTelcoCodesText"
                     class="show_more two">{{ showMoreUnfinishedTelcoCodesText }} </a>
                  <i class="fashow one fa"
                     :class="showMoreUnfinishedTelcoCodesText === 'Toon meer' ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                </div>
                <div v-if="unfinishedTelcoCodesLength <= 0" class="text">Geen Surprises om te
                  claimen.
                </div>

              </div>

              <hr class="for_border_black"/>

              <!--   unclaimed physical  -->
              <div class="cards_box_cont">

                <div v-if="unfinishedPhysicalCodesLength > 0" class="text">Aantal gewonnen
                  hoofdprijzen:
                  {{ unfinishedPhysicalCodesLength }}
                </div>
                <div v-if="unfinishedPhysicalCodesLength > 0" class="codes_inside first table_prnt"
                     v-for="(item, index) in unfinishedPhysicalCodes">
                  <div class="table_chld inside_img">
                    <img src="static/img/millen_images/present.png">
                  </div>
                  <div class="table_chld">
                    <div class="table_chld inside_text">
                      <p class="code">Speelcode: {{ unfinishedPhysicalCodes[index].code }}</p>
                      <p class="date">Geldig t/m:
                        {{ unfinishedPhysicalCodes[index].redemptionDate | formatDate }} </p>
                    </div>
                    <div class="table_chld inside_button">
                      <button
                        @click.prevent="redirectCustomer(unfinishedPhysicalCodes[index].code)"
                        type="button" class="black_btn">Claim je prijs
                      </button>
                    </div>
                  </div>
                </div>
                <div v-if="unfinishedPhysicalCodesLength <= 0" class="text">Geen hoofdprijzen om te
                  claimen.
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="sect_prizen_end">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="text-center">Mijn ontvangen prijzen</h1>
          </div>
        </div>
      </div>

      <!--   telco_carousel  -->
      <div class="container">
        <swiper v-if="listOfNetworkRewardsLength > 0" ref="mySwiper"
                class="swiper swiper_winners acc_prize_carousel"
                :options="carouselOptions" navigation>
          <swiper-slide v-for="(value, key) in listOfNetworkRewards" :key="key"
                        class="swiper-slide">
            <div class="slide_contains">
              <img :src="telcoPrizeIcon(key)"/>
              <p>{{ calculateSumOfTelcoPrize(key, value) }} </p>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-next" slot="button-next"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
        </swiper>
      </div>

      <!--   physical_carousel  -->
      <div class="container  ">
        <swiper v-if="listOfTangibleRewardsLength > 0" ref="mySwiper"
                class="swiper swiper_winners acc_prize_carousel"
                :options="carouselOptions" navigation>
          <swiper-slide v-for="(item, index) in listOfTangibleRewards"
                        :key="listOfTangibleRewards[index].rewardName"
                        class="width_slide">
            <div class="slide_contains">
              <div class="slide_contains_image">
                <img :src="listOfTangibleRewards[index].rewardImageUrl" alt="">
              </div>
              <div class="slide_contains_text">
                <div class="prize_title">{{ listOfTangibleRewards[index].rewardName }}</div>
                <div class="prize_date">{{
                  listOfTangibleRewards[index].rewardReservedDate | formatDate
                  }}
                </div>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-next" slot="button-next"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
        </swiper>
        <div v-if="(listOfNetworkRewardsLength <= 0 && listOfTangibleRewardsLength <= 0)"
             class="cards_box">
          <div class="cards_box_cont">
            <div class="text">Je hebt nog geen prijzen gewonnen. Waardeer op, speel het spel en
              claim jouw prijs!
            </div>
          </div>
        </div>

        <div class="account_links">
          <a href="#" @click.prevent="goToChangePassword()">Wachtwoord wijzigen</a>
        </div>
        <div class="account_links">
          <a href="#" @click.prevent="goToOptOut()"
             class="text-right text-lg-left text-md-left text-sm-left">Afmelden
            voor Prepaid Surprise</a>
        </div>
      </div>

    </div>

    <div class="cards_section end_section">
      <div class="container">
        <div class="row justify-content-center">
          <h1>Doe mee en win</h1>
        </div>
        <div class="row justify-content-center">

          <div class="card second">
            <img src="static/img/millen_images/left_image_cards.png">
            <div class="d-flex flex-column text-center card_content">
              <div class="card_text">
                Wil je een nieuwe speelcode, waardeer dan nu op.
              </div>
              <span class="arrow_blue">
                <a href="https://opwaarderen.odido.nl" target="_blank">Nu opwaarderen</a>
              </span>
            </div>
          </div>

          <div class="card ">
            <img src="static/img/millen_images/bundles_image_cards.png">
            <div class="d-flex flex-column text-center card_content">
              <div class="card_text">
                Een nieuwe speelcode? Koop via iDEAL een bundel van minstens €7,50.
              </div>
              <span class="arrow_blue"> <a href="https://www.odido.nl/mobiel/prepaid/bundels" target="blank">Koop een bundel</a></span>
            </div>

        </div>
        </div>

      </div>
    </div>

    <opt-out-popup v-if="optOutModalOpen()"></opt-out-popup>
    <change-password-popup v-if="changePasswordModalOpen()"></change-password-popup>
  </div>
</template>

<script>
  import {mapGetters, mapMutations, mapActions} from 'vuex'
  import OptOut from './modals/OptOut';
  import ChangePassword from './modals/ChangePassword';
  import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
  import gameFlow from '../common/mixin/gameFlow'
  import router from '../router'

  export default {
    name: "Account",
    mixins: [
      gameFlow
    ],
    components: {
      'opt-out-popup': OptOut,
      'change-password-popup': ChangePassword,
      Swiper,
      SwiperSlide
    },

    data() {
      return {
        percentageOfRedeemedCodesRounded: 0,
        pendingCodesLength: 0,
        pendingCodesVisible: 3,
        pendingCodes: [],
        showMorePendingCodesText: "Toon meer",

        unfinishedTelcoCodesLength: 0,
        unfinishedTelcoCodesVisible: 3,
        unfinishedTelcoCodes: [],
        showMoreUnfinishedTelcoCodesText: "Toon meer",

        unfinishedPhysicalCodesLength: 0,
        unfinishedPhysicalCodesVisible: 3,
        unfinishedPhysicalCodes: [],

        listOfNetworkRewards: [],
        listOfNetworkRewardsLength: 0,
        listOfTangibleRewards: [],
        listOfTangibleRewardsLength: 0,

        carouselOptions: {
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          breakpoints: {
            0: {
              slidesPerView: 1,
              spaceBetween: 30,
            },
            320: {
              slidesPerView: 1.4,
              spaceBetween: 20,
              centeredSlides: true,
              initialSlide: 1
            },
            576: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
        },
      }
    },
    mounted() {
      window.scrollTo(0, 0)
      // console.log('is gtm enabled? ' + this.$gtm.enabled())
      // this.$gtm.trackView('Account', window.location.href)
      this.loadMyAccount()
        .then(() => {
          this.percentageOfRedeemedCodesRounded = Math.round(this.getAccountResponse.percentageOfRedeemedCodesRounded * 100)

          this.pendingCodesLength = (this.getAccountResponse.pendingCodes !== null) ? this.getAccountResponse.pendingCodes.length : 0
          this.pendingCodes = this.getAccountResponse.pendingCodes

          this.unfinishedTelcoCodesLength = (this.getAccountResponse.unfinishedTelcoCodes !== null) ? this.getAccountResponse.unfinishedTelcoCodes.length : 0
          this.unfinishedTelcoCodes = this.getAccountResponse.unfinishedTelcoCodes

          this.unfinishedPhysicalCodesLength = (this.getAccountResponse.unfinishedPhysicalCodes !== null) ? this.getAccountResponse.unfinishedPhysicalCodes.length : 0
          this.unfinishedPhysicalCodes = this.getAccountResponse.unfinishedPhysicalCodes

          this.listOfNetworkRewards = this.getAccountResponse.listOfNetworkRewards
          this.listOfNetworkRewardsLength = (this.getAccountResponse.listOfNetworkRewards !== null) ? Object.keys(this.listOfNetworkRewards).length : 0

          this.listOfTangibleRewards = this.getAccountResponse.listOfTangibleRewards
          this.listOfTangibleRewardsLength = (this.getAccountResponse.listOfTangibleRewards) ? this.listOfTangibleRewards.length : 0
          this.updateSumOfOpenActions(this.pendingCodesLength + this.unfinishedTelcoCodesLength + this.unfinishedPhysicalCodesLength)

        })
      this.setInGameFlow("false", this.$route.params)
    },
    computed: {
      ...mapGetters([
        'isOptOutModalOpen',
        'isChangePasswordModalOpen',
        'getMsisdn',
        'getAccountResponse',
        'getGameFlowState',
        'getAccessToken',
        'getInGameFlow'
      ]),

      swiper() {
        return this.$refs.mySwiper.$swiper
      },

      visiblePendingCodes() {
        return this.pendingCodes.slice(0, this.pendingCodesVisible)
      },

      visibleUnfinishedTelcoCodes() {
        return this.unfinishedTelcoCodes.slice(0, this.unfinishedTelcoCodesVisible)
      }

    },
    methods: {
      ...mapMutations([
        'updateOptOutModal',
        'updateChangePasswordModal',
        'updateSumOfOpenActions',
        'updateSelectedCodeForRedemption',
        'updateRedemptionMsisdn',
        'updateInGameFlow'
      ]),

      ...mapActions([
        'loadMyAccount',
        'redeemCode'

      ]),

      hasAccessToken() {
        if (!this.getAccessToken) {
          router.push({name: 'Home'})
          return false
        } else {
          return true
        }
      },

      calculateTierTitle() {
        if (this.percentageOfRedeemedCodesRounded >= 1 && this.percentageOfRedeemedCodesRounded <= 50) {
          return 'Surprise Ontdekker'
        } else if (this.percentageOfRedeemedCodesRounded >= 51 && this.percentageOfRedeemedCodesRounded <= 90) {
          return 'Surprise Superspeler'
        } else if (this.percentageOfRedeemedCodesRounded >= 91 && this.percentageOfRedeemedCodesRounded <= 100) {
          return 'Surprise Eindbaas'
        }
      },

      tierIcon() {
        if (this.percentageOfRedeemedCodesRounded >= 1 && this.percentageOfRedeemedCodesRounded <= 50) {
          return 'explorer.png'
        } else if (this.percentageOfRedeemedCodesRounded >= 51 && this.percentageOfRedeemedCodesRounded <= 90) {
          return 'adventurer.png'
        } else if (this.percentageOfRedeemedCodesRounded >= 91 && this.percentageOfRedeemedCodesRounded <= 100) {
          return 'master.png'
        }

      },

      optOutModalOpen() {
        return this.isOptOutModalOpen
      },

      goToOptOut() {
        this.updateOptOutModal(true)
      },

      changePasswordModalOpen() {
        return this.isChangePasswordModalOpen
      },

      goToChangePassword() {
        this.updateChangePasswordModal(true)
      },

      showMorePendingCodes() {
        let numOfCodes = this.pendingCodesLength - this.pendingCodesVisible
        this.showMorePendingCodesText = (numOfCodes > 0) ? "Toon meer" : "Toon minder"

        if (this.showMorePendingCodesText === "Toon meer") {

          if (numOfCodes >= 3) {
            this.pendingCodesVisible += 3
          } else {
            this.pendingCodesVisible += numOfCodes
            this.showMorePendingCodesText = "Toon minder"
          }
        } else {
          this.pendingCodesVisible = 3
          this.showMorePendingCodesText = "Toon meer"
        }
      },

      showMoreUnfinishedTelcoCodes() {
        let numOfCodes = this.unfinishedTelcoCodesLength - this.unfinishedTelcoCodesVisible
        this.showMoreUnfinishedTelcoCodesText = (numOfCodes > 0) ? "Toon meer" : "Toon minder"

        if (this.showMoreUnfinishedTelcoCodesText === "Toon meer") {
          if (numOfCodes >= 3) {
            this.unfinishedTelcoCodesVisible += 3
          } else {
            this.unfinishedTelcoCodesVisible += numOfCodes
            this.showMoreUnfinishedTelcoCodesText = "Toon minder"
          }
        } else {
          this.unfinishedTelcoCodesVisible = 3
          this.showMoreUnfinishedTelcoCodesText = "Toon meer"
        }
      },

      calculateSumOfTelcoPrize(key, value) {
        let finalValue = value
        key.toUpperCase()
        console.log(key.toUpperCase())

        if (key === 'DATA')
          finalValue = value + " MB"
        if (key === 'VOICE')
          finalValue = value + " Belminuten"
        if (key === 'SMS')
          finalValue = value + " Sms'jes"
        if (key === 'FREE_RECHARGE')
          finalValue = "€"+value + " Promo-tegoed"

        console.log(finalValue)
        return finalValue

      },

      telcoPrizeIcon(key) {
        let icon = ''
        key.toUpperCase()

        if (key === 'DATA')
          icon = 'static/img/millen_images/icons/telco_icon_net.png'
        if (key === 'VOICE')
          icon = 'static/img/millen_images/icons/telco_icon_time.png'
        if (key === 'SMS')
          icon = 'static/img/millen_images/icons/telco_icon_sms.png'
        if (key === 'FREE_RECHARGE')
          icon = 'static/img/millen_images/icons/telco_icon_promo.png'

        return icon
      },

      redirectCustomer(code) {
        this.updateRedemptionMsisdn(this.getMsisdn)
        this.updateSelectedCodeForRedemption(code)
        this.redeemCode()
          .then((response) => {
            this.$store.commit('updateGameFlowState', response.data.currentConversationState)
            this.loadInfoFromConversation(response)
            this.gameRouting()
          })
      }

    }
  }
</script>

<style scoped>
  .swiper-slide {
    margin-bottom: 50px;
    top: 10px;
    left: 5px;
  }

  .swiper_winners {
    padding-right: 13px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Account.vue